export default __webpack_public_path__ + "static/media/thumbnail1.678a740d.jpg";